import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ExperienceAccordion = ({
  experienceListBlock = [],
  updateExperienceBlock,
  onDeleteExperienceBlock,
  setExperienceIndex,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseFour"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseFour"
        >
          {t("Experience")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      {/* ----- experience block list section start ----- */}
      <div
        id="panelsStayOpen-collapseFour"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          <div className="fields-group">
            <div className="fields d-flex flex-column gap-3">
              {/* ------ experience list section start ------ */}
              {experienceListBlock.map((experience, index) => {
                return (
                  <div className="field" key={index}>
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Company")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                            {experience.companyid
                              ? experience.companyid.label
                              : experience.company}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Position")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                            {experience.position}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Start Year")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {experience.start}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("To Year")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {experience.end}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                        <Link
                          to="#"
                          className="text-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#addExperienceModal"
                          onClick={() =>
                            updateExperienceBlock(experience, index)
                          }
                        >
                          <span className="d-block material-symbols-outlined">
                            edit
                          </span>
                        </Link>
                        <button
                          type="button"
                          className="btn p-0 border-0 bg-transparent text-danger"
                          onClick={() => onDeleteExperienceBlock(index)}
                        >
                          <span className="d-block material-symbols-outlined">
                            delete
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* ------ experience list section end ------ */}
            </div>
            {/* ------ add experience modal button start ------ */}
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#addExperienceModal"
              onClick={() => {
                setExperienceIndex(null);
              }}
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1 mt-3"
            >
              <span className="d-block material-symbols-outlined">add</span>
              <span className="d-block">{t("Add Experience")}</span>
            </Link>
            {/* ------ add experience modal button end ------ */}
          </div>
        </div>
      </div>
      {/* ----- experience block list section end ----- */}
    </div>
  );
};

export default ExperienceAccordion;
